/**
 * 宿泊詳細の初期化
 */
export function initStayDetail($) {
  if ($('body.single-stay').length === 0) return;

  const itemCount = $('.s-stay-detail__slide--main .c-slide__item').length;

  // 画像が1枚の場合はサムネイルを非表示
  if (itemCount === 1) {
    $('.s-stay-detail__slide--sub').hide();
  }

  // メインスライド
  $('.s-stay-detail__slide--main').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: itemCount > 1 ? '#sub-slide' : null,
    focusOnSelect: true,
    centerMode: true,
    centerPadding: '0',
    variableWidth: true,
    infinite: itemCount > 1,
    arrows: true, // スマホ時は表示
    dots: false,
    responsive: [
      {
        breakpoint: 768, // md未満
        settings: {
          arrows: true,
        },
      },
      {
        breakpoint: 9999, // md以上
        settings: {
          arrows: false,
        },
      },
    ],
  });

  // サブスライド（2枚以上の場合のみ初期化）
  if (itemCount > 1) {
    $('.s-stay-detail__slide--sub').slick({
      slidesToShow: 5,
      asNavFor: '#main-slide',
      infinite: true,
      arrows: false, // スマホ時は非表示
      dots: false,
      focusOnSelect: true,
      centerMode: true,
      centerPadding: '0',
      responsive: [
        {
          breakpoint: 768, // md未満
          settings: {
            arrows: false,
          },
        },
        {
          breakpoint: 9999, // md以上
          settings: {
            arrows: true,
          },
        },
      ],
    });

    $('.s-stay-detail__slide--sub').each(function() {
      if ($(this).find('.c-slide__item').length <= 5) {
        $(this)
          .find('.slick-track')
          .addClass('no-scroll-center');
      }
    });
  }
}
